export default __webpack_public_path__ + "static/casa-700dab16aace29caf09307d5ec30d114.png";